// Simple Translation System

// ============================================================================
// IIFE Wrapper - verhindert "duplicate variable" Fehler
// ============================================================================

(function() {
    'use strict';

const translations: Record<string, Record<string, string>> = {
    de: {
        "tickets.panel.description": "Erstellen Sie Support-Anfragen und verfolgen Sie Antworten und den aktuellen Bearbeitungsstand.",
        "tickets.filter.search": "Tickets durchsuchen",
        "tickets.filter.searchPlaceholder": "Ticketnummer oder Betreff",
        "tickets.filter.reset": "Filter zurücksetzen",
        "tickets.filter.noResults": "Keine passenden Tickets",
        "tickets.filter.noResultsHint": "Ändern Sie Ihre Suche oder setzen Sie die Filter zurück.",
        "tickets.filter.results": "{count} Tickets angezeigt",
        "tickets.create.intro": "Was funktioniert nicht, seit wann und was haben Sie bereits versucht? Pflichtfelder sind mit * markiert.",
        "tickets.create.priorityHelp": "Wählen Sie Dringend nur bei einem Ausfall, der Ihre Arbeit blockiert.",
        "tickets.create.description.help": "Nennen Sie betroffene Dienste, Zeitpunkt und Fehlermeldungen (mindestens 10 Zeichen). Bitte keine Passwörter senden.",

        'nav.home': 'Start',
        'nav.services': 'Leistungen',
        'nav.about': 'Über uns',
        'nav.team': 'Team',
        'nav.contact': 'Kontakt',
        'nav.portal': 'Kundenbereich',
        'hero.title': 'Zuverlässige Hosting-Lösungen für Ihr Unternehmen',
        'hero.subtitle': 'Als Microsoft Cloud Solution Provider bieten wir maßgeschneiderte Cloud-Lösungen, Private Cloud Infrastructure und SPLA-Lizenzierung für Unternehmen jeder Größe.',
        'hero.cta.primary': 'Kontaktieren Sie uns',
        'hero.cta.secondary': 'Unsere Leistungen',
        'services.title': 'Unsere Leistungen',
        'services.subtitle': 'Professionelle Cloud- und Hosting-Lösungen für Ihr Unternehmen',
        'services.csp.title': 'Microsoft Cloud Solution Provider',
        'services.csp.description': 'Als autorisierter Microsoft CSP bieten wir direkten Zugang zu Microsoft 365, Azure und allen Microsoft Cloud-Diensten mit persönlichem Support und Beratung.',
        'services.private.title': 'Private Cloud',
        'services.private.description': 'Hochsichere, dedizierte Cloud-Infrastruktur in österreichischen Rechenzentren. Maximale Kontrolle, Compliance und Performance für Ihre kritischen Geschäftsanwendungen.',
        'services.spla.title': 'SPLA Lizenzprogramm',
        'services.spla.description': 'Flexible Microsoft SPLA-Lizenzierung für Service Provider. Monatliche Abrechnung nach tatsächlicher Nutzung ohne langfristige Verpflichtungen.',
        'about.title': 'Über Cyberplex',
        'about.description': 'Seit unserer Gründung sind wir spezialisiert auf innovative Cloud- und Hosting-Lösungen für Unternehmen. Als Microsoft Cloud Solution Provider verbinden wir technische Expertise mit persönlichem Service.',
        'about.values.security.title': 'Sicherheit',
        'about.values.security.desc': 'Höchste Standards an Datenschutz und Datensicherheit',
        'about.values.reliability.title': 'Verfügbarkeit',
        'about.values.reliability.desc': '99,9% Uptime-Garantie für alle Services',
        'about.values.support.title': 'Support',
        'about.values.support.desc': 'Persönliche Betreuung durch erfahrene Experten',
        'team.title': 'Unser Team',
        'team.subtitle': 'Erfahrene Experten für Ihre Cloud- und Hosting-Lösungen',
        'team.member1.name': 'Maximilian Kowalski',
        'team.member1.role': 'Geschäftsführer',
        'team.member2.name': 'Sarah Weber',
        'team.member2.role': 'Cloud Architect',
        'team.member3.name': 'Thomas Müller',
        'team.member3.role': 'Technical Lead',
        'team.member4.name': 'Lisa Huber',
        'team.member4.role': 'Customer Success Manager',
        'contact.title': 'Kontaktieren Sie uns',
        'contact.description': 'Haben Sie Fragen zu unseren Dienstleistungen? Wir sind für Sie da.',
        'contact.email.label': 'E-Mail',
        'contact.address.label': 'Adresse',
        'contact.form.name.label': 'Name',
        'contact.form.name.placeholder': 'Ihr Name',
        'contact.form.email.label': 'E-Mail',
        'contact.form.email.placeholder': 'ihre@email.at',
        'contact.form.message.label': 'Nachricht',
        'contact.form.message.placeholder': 'Ihre Nachricht...',
        'contact.form.submit': 'Nachricht senden',
        'contact.form.success.title': 'Danke für Ihre Nachricht!',
        'contact.form.success.message': 'Wir werden uns so schnell wie möglich bei Ihnen melden.',
        'footer.description': 'Ihr Microsoft Cloud Solution Provider für innovative Cloud- und Hosting-Lösungen.',
        'footer.links.title': 'Links',
        'footer.links.services': 'Leistungen',
        'footer.links.about': 'Über uns',
        'footer.links.contact': 'Kontakt',
        'footer.links.login': 'Kunden-Login',
        'footer.legal.title': 'Rechtliches',
        'footer.legal.privacy': 'Datenschutz',
        'footer.legal.imprint': 'Impressum',
        'footer.copyright': '© 2024 Cyberplex. Alle Rechte vorbehalten.',
        'footer.cookieSettings': 'Cookie-Einstellungen',
        'cookies.title': 'Cookie-Einstellungen',
        'cookies.description': 'Wir verwenden Cookies, um Ihre Spracheinstellung zu speichern und anonyme Besucherstatistiken zu erfassen. Detaillierte Informationen finden Sie in unserer Datenschutzerklärung.',
        'cookies.necessary.title': 'Notwendige Cookies',
        'cookies.necessary.description': 'Diese Cookies sind für die Grundfunktionen der Website erforderlich, einschließlich Login-Sessions (60 Minuten). Keine Tracking-Cookies durch uns.',
        'cookies.analytics.title': 'Anonyme Statistik',
        'cookies.analytics.description': 'Erfasst anonymisierte Daten über die Nutzung der Website zur Verbesserung unseres Angebots. Keine personenbezogenen Daten werden gespeichert.',
        'cookies.alwaysOn': 'Immer aktiv',
        'cookies.decline': 'Ablehnen',
        'cookies.save': 'Auswahl speichern',
        'cookies.acceptAll': 'Alle akzeptieren',
        'login.title': 'Kunden-Login',
        'login.subtitle': 'Anmelden per Passkey oder per E-Mail-Link (E-Mail-Link 15 Minuten gueltig).',
        'login.passkey': 'Mit Passkey anmelden',
        'login.email.label': 'E-Mail',
        'login.email.placeholder': 'ihre@email.at',
        'login.submit': 'Anmelde-Link senden',
        'login.divider': 'oder',
        'login.signup.toggle': 'Neu hier? Konto erstellen',
        'login.signup.title': 'Konto erstellen',
        'login.signup.hint': 'Verwenden Sie Ihre Firmen-E-Mail-Adresse mit gültigem Mailserver. Freemail- und Wegwerf-Adressen sind nicht zugelassen. Nach E-Mail-Bestätigung prüfen wir Ihr Konto.',
        'login.signup.submit': 'Konto erstellen',
        'login.signup.email.label': 'E-Mail',
        'login.signup.email.placeholder': 'ihre@email.at',
        'logout.timer': 'Automatische Abmeldung in: {time}',
        'dashboard.user': 'Angemeldet als',
        'dashboard.subtitle': 'Ihr Kundenbereich wird schrittweise erweitert.',
        'dashboard.menu.email': 'E-Mail ändern',
        'dashboard.menu.logout': 'Abmelden',
        'email.title': 'E-Mail ändern',
        'email.current.label': 'Aktuelle E-Mail',
        'email.current.placeholder': 'ihre@email.at',
        'email.new.label': 'Neue E-Mail',
        'email.new.placeholder': 'neu@email.at',
        'email.submit': 'E-Mail ändern',
        'mail.title': 'Mail-Einstellungen',
        'mail.host.label': 'Mailserver',
        'mail.host.placeholder': 'smtp.example.com',
        'mail.port.label': 'Port',
        'mail.port.placeholder': '587',
        'mail.user.label': 'Benutzerkonto',
        'mail.user.placeholder': 'user@example.com',
        'mail.pass.label': 'Passwort',
        'mail.pass.placeholder': '********',
        'mail.from.label': 'Absender E-Mail',
        'mail.from.placeholder': 'noreply@example.com',
        'mail.to.label': 'Empfänger E-Mail',
        'mail.to.placeholder': 'test@example.com',
        'mail.tls': 'TLS verwenden (STARTTLS)',
        'mail.note': 'Passwort wird verschlüsselt gespeichert.',
        'mail.save': 'Einstellungen speichern',
        'mail.test': 'Testmail senden',
        'consents.panel.title': 'Einwilligungen & Vereinbarungen',
        'consents.loading': 'Lade...',
        'consents.error': 'Fehler beim Laden der Einwilligungen.',
        'consents.retry': 'Erneut versuchen',
        'consents.status.accepted': 'Bestätigt',
        'consents.status.pending': 'Ausstehend',
        'consents.label.privacy_consent': 'DSGVO Einwilligung',
        'consents.label.cloud_agreement': 'Cloud Agreement',
        'consents.label.terms_accepted': 'AGB',
        'consents.label.privacy_notice_customer_portal': 'Datenschutzerklärung',
        'consents.label.cookie_consent': 'Cookie Consent',
        'consents.meta.version': 'Version',
        'consents.meta.date': 'Datum',
        'consents.cta.text': 'Einige Einwilligungen sind noch ausstehend.',
        'consents.cta.button': 'Jetzt bestätigen',
        'reactivation.status.title': 'Account deaktiviert',
        'reactivation.status.message': 'Ihr Account ist deaktiviert. Sie haben noch {days} Tage Zeit, eine Reaktivierung zu beantragen.',
        'reactivation.status.ticket_open': 'Es besteht bereits eine offene Reaktivierungsanfrage ({ticket}).',
        'reactivation.status.ticket_status': 'Status: {status}',
        'reactivation.button.request': 'Reaktivierung beantragen',
        'reactivation.button.pending': 'Anfrage läuft...',
        'reactivation.email.sent': 'Falls ein deaktivierter Account existiert, wurde ein Link per E-Mail gesendet.',
        'reactivation.success.message': 'Reaktivierungsanfrage erstellt. Sie erhalten eine E-Mail mit weiteren Informationen.',
        'reactivation.error.generic': 'Fehler bei der Reaktivierung. Bitte versuchen Sie es später erneut.',
        'reactivation.page.title': 'Account-Reaktivierung',
        'reactivation.page.subtitle': 'Bestätigen Sie Ihre Identität, um Ihren Account zu reaktivieren.',
        'reactivation.verify.success': 'Ihre E-Mail wurde bestätigt. Sie können jetzt eine Reaktivierungsanfrage erstellen.',
        'reactivation.ticket.info': 'Ticket: {number}',
        'reactivation.ticket.status': 'Status: {status}',
        'reactivation.ticket.hint': 'Klicken Sie auf den Button unten, um Ihre Reaktivierungsanfrage zu erstellen.',
        'reactivation.ticket.create': 'Reaktivierungsanfrage erstellen',
        'reactivation.ticket.creating': 'Wird erstellt...',
        'reactivation.ticket.created': 'Ticket erstellt. Bitte bestätigen Sie Ihre Identität.',
        'reactivation.stepup.hint': 'Um Ihre Anfrage abzuschließen, bestätigen Sie bitte Ihre Identität mit einem Passkey.',
        'reactivation.stepup.button': 'Identität mit Passkey bestätigen',
        'reactivation.stepup.pending': 'Bitte folgen Sie den Anweisungen Ihres Passkeys...',
        'reactivation.stepup.success': 'Identität bestätigt! Ihre Anfrage wird bearbeitet.',
        'reactivation.stepup.error': 'Bestätigung fehlgeschlagen. Bitte versuchen Sie es erneut.',
        'reactivation.existing.ticket': 'Sie haben bereits eine offene Reaktivierungsanfrage.',
        'reactivation.existing.message': 'Ihre Anfrage wird bearbeitet. Sie erhalten eine E-Mail, sobald Ihr Account wieder aktiviert ist.',
        'reactivation.success.info': 'Sie erhalten eine E-Mail, sobald Ihr Account wieder aktiviert ist.',
        'admin.tickets.filter.reactivation': 'Reaktivierungen',
        'admin.tickets.badge.reactivation': 'Reaktivierung',
        'admin.tickets.stepup.pending': 'Step-Up ausstehend',
        'admin.tickets.stepup.verified': 'Step-Up bestätigt',
        'admin.tickets.action.approve': 'Genehmigen',
        'admin.tickets.action.reject': 'Ablehnen',
        'admin.tickets.reject.reason': 'Ablehnungsgrund',
        'admin.tickets.approve.success': 'Reaktivierung genehmigt',
        'admin.tickets.reject.success': 'Reaktivierung abgelehnt',
        'tickets.panel.title': 'Meine Support-Tickets',
        'tickets.panel.empty': 'Keine Tickets vorhanden',
        'tickets.panel.empty.hint': 'Erstellen Sie ein neues Ticket, um Support zu erhalten.',
        'tickets.panel.create': 'Neues Ticket',
        'tickets.panel.back': 'Zurück zur Liste',
        'tickets.panel.loading': 'Lade Tickets...',
        'tickets.panel.error': 'Fehler beim Laden der Tickets.',
        'tickets.panel.retry': 'Erneut versuchen',
        'tickets.filter.status': 'Status',
        'tickets.filter.category': 'Kategorie',
        'tickets.filter.all': 'Alle',
        'tickets.list.comments': 'Kommentare',
        'tickets.detail.title': 'Ticket-Details',
        'tickets.detail.description': 'Beschreibung',
        'tickets.detail.comments': 'Kommentare',
        'tickets.detail.noComments': 'Noch keine Kommentare.',
        'tickets.detail.addComment': 'Kommentar hinzufügen',
        'tickets.detail.commentPlaceholder': 'Ihre Nachricht...',
        'tickets.detail.commentSubmit': 'Absenden',
        'tickets.detail.close': 'Ticket schließen',
        'tickets.detail.closeConfirm': 'Möchten Sie dieses Ticket wirklich schließen?',
        'tickets.detail.closeReason': 'Grund (optional)',
        'tickets.create.title': 'Neues Ticket erstellen',
        'tickets.create.subject': 'Betreff',
        'tickets.create.subjectPlaceholder': 'Kurze Zusammenfassung',
        'tickets.create.category': 'Kategorie',
        'tickets.create.priority': 'Priorität',
        'tickets.create.description': 'Beschreibung',
        'tickets.create.descriptionPlaceholder': 'Detaillierte Beschreibung Ihres Anliegens...',
        'tickets.create.submit': 'Ticket erstellen',
        'tickets.create.cancel': 'Abbrechen',
        'tickets.create.success': 'Ticket erfolgreich erstellt',
        'tickets.create.error': 'Fehler beim Erstellen des Tickets',
        'tickets.status.open': 'Offen',
        'tickets.status.in_progress': 'In Bearbeitung',
        'tickets.status.waiting_customer': 'Ihre Antwort wird benötigt',
        'tickets.status.waiting_internal': 'Interne Prüfung',
        'tickets.status.resolved': 'Gelöst',
        'tickets.status.closed': 'Geschlossen',
        'tickets.status.cancelled': 'Storniert',
        'tickets.priority.low': 'Niedrig',
        'tickets.priority.medium': 'Mittel',
        'tickets.priority.high': 'Hoch',
        'tickets.priority.urgent': 'Dringend',
        'tickets.category.general': 'Allgemeine Anfrage',
        'tickets.category.technical': 'Technischer Support',
        'tickets.category.billing': 'Rechnungen & Verträge',
        'tickets.category.account': 'Zugang & Benutzer',
        'tickets.category.feature_request': 'Änderungswunsch',
        'tickets.category.bug_report': 'Fehler melden',
        'tickets.category.security': 'Sicherheitsvorfall',
        'tickets.category.provision_request': 'Bestellung / Bereitstellung',
        'tickets.comment.success': 'Kommentar hinzugefügt',
        'tickets.comment.error': 'Fehler beim Hinzufügen des Kommentars',
        'tickets.close.success': 'Ticket geschlossen',
        'tickets.close.error': 'Fehler beim Schließen des Tickets',
        'tickets.attachments.label': 'Dateianhänge (optional)',
        'tickets.attachments.select': 'Dateien auswählen...',
        'tickets.attachments.hint': 'Max. 5 Dateien, je max. 10MB. Erlaubt: Bilder, PDF, Office-Dokumente, Text, Logs.',
        'tickets.attachments.section': 'Anhänge',
        'tickets.attachments.download': 'Herunterladen',
        'tickets.attachments.remove': 'Entfernen',
        'tickets.attachments.error.tooMany': 'Maximal 5 Dateien erlaubt',
        'tickets.attachments.error.tooLarge': 'Datei zu groß (max. 10MB)',
        'tickets.attachments.error.invalidType': 'Dateityp nicht erlaubt',
        'tickets.attachments.error.multi': '{count} Dateien konnten nicht hinzugefügt werden: {reasons}',
        'tickets.attachments.uploading': 'Upload läuft',
        'tickets.attachments.dropzoneHint': 'Dateien hierher ziehen oder klicken zum Auswählen',
        'tickets.reactivation.exists': 'Es existiert bereits eine offene Reaktivierungsanfrage.',
        'tickets.reactivation.link': 'Zum Ticket',
        'consent.privacy.title': 'DSGVO Einwilligung',
        'consent.cloud.title': 'Cloud Agreement',
        'consent.terms.title': 'AGB',
        'consent.accept': 'Akzeptieren',
        'consent.accepted': 'Einwilligung erfolgreich gespeichert',
        // SLA Report Panel
        'admin.slaReport.title': 'SLA Compliance Bericht',
        'admin.slaReport.subtitle': 'Service Level Agreement Statistiken',
        'admin.slaReport.filters': 'Filter',
        'admin.slaReport.dateFrom': 'Von',
        'admin.slaReport.dateTo': 'Bis',
        'admin.slaReport.category': 'Kategorie',
        'admin.slaReport.categoryAll': 'Alle Kategorien',
        'admin.slaReport.generate': 'Bericht erstellen',
        'admin.slaReport.exportJson': 'JSON Export',
        'admin.slaReport.exportCsv': 'CSV Export',
        'admin.slaReport.summary': 'Zusammenfassung',
        'admin.slaReport.totalTickets': 'Tickets gesamt',
        'admin.slaReport.ticketsWithSla': 'Tickets mit SLA',
        'admin.slaReport.responseCompliance': 'Reaktions-Compliance',
        'admin.slaReport.resolutionCompliance': 'Lösungs-Compliance',
        'admin.slaReport.avgResponseTime': 'Ø Reaktionszeit',
        'admin.slaReport.avgResolutionTime': 'Ø Lösungszeit',
        'admin.slaReport.breachesByCategory': 'Überschreitungen nach Kategorie',
        'admin.slaReport.breachesByPriority': 'Überschreitungen nach Priorität',
        'admin.slaReport.hours': 'Stunden',
        'admin.slaReport.noData': 'Keine Daten für den gewählten Zeitraum',
        'admin.slaReport.loading': 'Lade SLA-Daten...',
        'admin.slaReport.error': 'Fehler beim Laden des SLA-Berichts',
        'admin.slaReport.dateRangeError': 'Zeitraum darf maximal 1 Jahr betragen',
        // Onboarding Tour
        'admin.onboarding.title': 'Willkommen im Admin Dashboard',
        'admin.onboarding.subtitle': 'Lernen Sie die wichtigsten Funktionen kennen',
        'admin.onboarding.step': 'Schritt {current} von {total}',
        'admin.onboarding.steps.1.title': 'Willkommen!',
        'admin.onboarding.steps.1.description': 'Willkommen im Cyberplex Admin Dashboard. Hier verwalten Sie Benutzer, Tickets und Systemeinstellungen.',
        'admin.onboarding.steps.2.title': 'Benutzerverwaltung',
        'admin.onboarding.steps.2.description': 'Genehmigen Sie neue Accounts, verwalten Sie Benutzer und laden Sie neue Benutzer ein.',
        'admin.onboarding.steps.3.title': 'Support-Tickets',
        'admin.onboarding.steps.3.description': 'Bearbeiten Sie Support-Anfragen und Reaktivierungsanfragen. Die SLA-Filter helfen bei der Priorisierung.',
        'admin.onboarding.steps.4.title': 'Audit-Protokolle',
        'admin.onboarding.steps.4.description': 'Verfolgen Sie alle System-Aktivitäten im Audit-Log. Exportieren Sie gefilterte Logs für Compliance.',
        'admin.onboarding.steps.5.title': 'System-Einstellungen',
        'admin.onboarding.steps.5.description': 'Konfigurieren Sie Mail-Einstellungen, erstellen Sie Datenbank-Backups und verwalten Sie Signup-Optionen.',
        'admin.onboarding.steps.6.title': 'Bereit!',
        'admin.onboarding.steps.6.description': 'Sie sind bereit! Bei Fragen klicken Sie auf das Hilfe-Symbol (?) oben rechts.',
        'admin.onboarding.back': 'Zurück',
        'admin.onboarding.next': 'Weiter',
        'admin.onboarding.skip': 'Überspringen',
        'admin.onboarding.finish': 'Fertig',
        'admin.onboarding.skipConfirm': 'Möchten Sie die Tour wirklich überspringen? Sie können sie später nicht erneut starten.',
        // GDPR Export
        'admin.gdprExport.title': 'Datenschutz-Export (GDPR)',
        'admin.gdprExport.description': 'Laden Sie alle Ihre gespeicherten Daten herunter. Maximale 1 Export pro 24 Stunden.',
        'admin.gdprExport.button': 'Meine Daten exportieren',
        'admin.gdprExport.loading': 'Export wird erstellt...',
        'admin.gdprExport.success': 'Export erstellt! Download verfügbar bis {expires}.',
        'admin.gdprExport.download': 'Herunterladen',
        'admin.gdprExport.error': 'Export fehlgeschlagen. Bitte versuchen Sie es später erneut.',
        'admin.gdprExport.rateLimit': 'Sie haben bereits einen Export angefordert. Bitte warten Sie {hours} Stunden.',
        'admin.gdprExport.info': 'Der Export enthält: Benutzerdaten, Profil, Firmenmitgliedschaften, Tickets, Kommentare, Audit-Logs.',
        // Home Panel
        'home.welcome': 'Willkommen',
        'home.welcomeBack': 'Willkommen zurück, {name}!',
        'home.stats.tickets': 'Offene Tickets',
        'home.stats.companies': 'Ihre Firmen',
        'home.stats.consents': 'Einwilligungen',
        'home.stats.pending': 'Ausstehend',
        'home.actions.newTicket': 'Neues Ticket',
        'home.actions.manageCompany': 'Firma verwalten',
        'home.actions.consents': 'Einwilligungen',
        'home.actions.help': 'Hilfe',
        'home.loading': 'Daten werden geladen...',
        'home.error': 'Daten konnten nicht geladen werden',
        // Notifications
        'notifications.title': 'Benachrichtigungen',
        'notifications.empty': 'Keine neuen Benachrichtigungen',
        'notifications.markAsRead': 'Als gelesen markieren',
        'notifications.markAllRead': 'Alle als gelesen',
        'notifications.viewAll': 'Alle anzeigen',
        'notifications.justNow': 'Gerade eben',
        'notifications.minutesAgo': 'vor {count} Minuten',
        'notifications.hoursAgo': 'vor {count} Stunden',
        'notifications.daysAgo': 'vor {count} Tagen',
        'notifications.types.ticket_comment': 'Ticket-Kommentar',
        'notifications.types.ticket_status': 'Ticket-Status',
        'notifications.types.company_invite': 'Firmen-Einladung',
        'notifications.types.reactivation': 'Reaktivierung',
        'notifications.types.security': 'Sicherheit',
        'notifications.types.system': 'System',
        // Onboarding
        'onboarding.step1.title': 'Willkommen bei Cyberplex!',
        'onboarding.step1.description': 'Lernen Sie Ihr Kundenportal kennen.',
        'onboarding.step2.title': 'Ihr Dashboard',
        'onboarding.step2.description': 'Hier sehen Sie alle wichtigen Informationen auf einen Blick.',
        'onboarding.step3.title': 'Support-Tickets',
        'onboarding.step3.description': 'Erstellen und verwalten Sie Support-Anfragen.',
        'onboarding.step4.title': 'Firmenverwaltung',
        'onboarding.step4.description': 'Verwalten Sie Ihre Firmendaten und Mitglieder.',
        'onboarding.next': 'Weiter',
        'onboarding.back': 'Zurück',
        'onboarding.skip': 'Überspringen',
        'onboarding.finish': 'Fertig',
        // Search
        'search.placeholder': 'Suchen...',
        'search.open': 'Suche öffnen',
        'search.close': 'Suche schließen',
        'search.loading': 'Suche läuft...',
        'search.empty.title': 'Keine Ergebnisse',
        'search.empty.hint': 'Versuchen Sie einen anderen Suchbegriff',
        'search.error': 'Suche fehlgeschlagen',
        'search.sections.tickets': 'Tickets',
        'search.sections.companies': 'Firmen',
        'search.sections.domains': 'Domains',
        // Version Footer
        'footer.version': 'Version'
    },
    en: {
        "tickets.panel.description": "Create support requests and follow replies and their current progress.",
        "tickets.filter.search": "Search tickets",
        "tickets.filter.searchPlaceholder": "Ticket number or subject",
        "tickets.filter.reset": "Reset filters",
        "tickets.filter.noResults": "No matching tickets",
        "tickets.filter.noResultsHint": "Change your search or reset the filters.",
        "tickets.filter.results": "{count} tickets shown",
        "tickets.create.intro": "What is not working, when did it start and what have you tried? Required fields are marked with *.",
        "tickets.create.priorityHelp": "Select Urgent only for an outage that prevents you from working.",
        "tickets.create.description.help": "Include affected services, timing and error messages (at least 10 characters). Please do not send passwords.",

        'nav.home': 'Home',
        'nav.services': 'Services',
        'nav.about': 'About',
        'nav.team': 'Team',
        'nav.contact': 'Contact',
        'nav.portal': 'Customer Portal',
        'hero.title': 'Reliable Hosting Solutions for Your Business',
        'hero.subtitle': 'As a Microsoft Cloud Solution Provider, we offer customized cloud solutions, private cloud infrastructure, and SPLA licensing for businesses of all sizes.',
        'hero.cta.primary': 'Contact Us',
        'hero.cta.secondary': 'Our Services',
        'services.title': 'Our Services',
        'services.subtitle': 'Professional cloud and hosting solutions for your business',
        'services.csp.title': 'Microsoft Cloud Solution Provider',
        'services.csp.description': 'As an authorized Microsoft CSP, we provide direct access to Microsoft 365, Azure, and all Microsoft cloud services with personal support and consulting.',
        'services.private.title': 'Private Cloud',
        'services.private.description': 'Highly secure, dedicated cloud infrastructure in Austrian data centers. Maximum control, compliance, and performance for your critical business applications.',
        'services.spla.title': 'SPLA License Program',
        'services.spla.description': 'Flexible Microsoft SPLA licensing for service providers. Monthly billing based on actual usage without long-term commitments.',
        'about.title': 'About Cyberplex',
        'about.description': 'Since our founding, we have specialized in innovative cloud and hosting solutions for businesses. As a Microsoft Cloud Solution Provider, we combine technical expertise with personal service.',
        'about.values.security.title': 'Security',
        'about.values.security.desc': 'Highest standards in data protection and security',
        'about.values.reliability.title': 'Reliability',
        'about.values.reliability.desc': '99.9% uptime guarantee for all services',
        'about.values.support.title': 'Support',
        'about.values.support.desc': 'Personal support from experienced experts',
        'team.title': 'Our Team',
        'team.subtitle': 'Experienced experts for your cloud and hosting solutions',
        'team.member1.name': 'Maximilian Kowalski',
        'team.member1.role': 'CEO',
        'team.member2.name': 'Sarah Weber',
        'team.member2.role': 'Cloud Architect',
        'team.member3.name': 'Thomas Müller',
        'team.member3.role': 'Technical Lead',
        'team.member4.name': 'Lisa Huber',
        'team.member4.role': 'Customer Success Manager',
        'contact.title': 'Contact Us',
        'contact.description': 'Do you have questions about our services? We are here for you.',
        'contact.email.label': 'Email',
        'contact.address.label': 'Address',
        'contact.form.name.label': 'Name',
        'contact.form.name.placeholder': 'Your name',
        'contact.form.email.label': 'Email',
        'contact.form.email.placeholder': 'your@email.com',
        'contact.form.message.label': 'Message',
        'contact.form.message.placeholder': 'Your message...',
        'contact.form.submit': 'Send Message',
        'contact.form.success.title': 'Thank you for your message!',
        'contact.form.success.message': 'We will get back to you as soon as possible.',
        'footer.description': 'Your Microsoft Cloud Solution Provider for innovative cloud and hosting solutions.',
        'footer.links.title': 'Links',
        'footer.links.services': 'Services',
        'footer.links.about': 'About',
        'footer.links.contact': 'Contact',
        'footer.links.login': 'Customer Login',
        'footer.legal.title': 'Legal',
        'footer.legal.privacy': 'Privacy Policy',
        'footer.legal.imprint': 'Imprint',
        'footer.copyright': '© 2024 Cyberplex. All rights reserved.',
        'footer.cookieSettings': 'Cookie Settings',
        'cookies.title': 'Cookie Settings',
        'cookies.description': 'We use cookies to save your language preference and collect anonymous visitor statistics. Detailed information can be found in our privacy policy.',
        'cookies.necessary.title': 'Necessary Cookies',
        'cookies.necessary.description': 'These cookies are required for basic functions, including login sessions (60 minutes). No tracking cookies are set by us.',
        'cookies.analytics.title': 'Anonymous Statistics',
        'cookies.analytics.description': 'Collects anonymized data about website usage to improve our services. No personal data is stored.',
        'cookies.alwaysOn': 'Always active',
        'cookies.decline': 'Decline',
        'cookies.save': 'Save selection',
        'cookies.acceptAll': 'Accept all',
        'login.title': 'Customer Login',
        'login.subtitle': 'Sign in using a passkey or an email link (email link valid for 15 minutes).',
        'login.passkey': 'Sign in with passkey',
        'login.email.label': 'Email',
        'login.email.placeholder': 'your@email.com',
        'login.submit': 'Send sign-in link',
        'login.divider': 'or',
        'login.signup.toggle': 'New here? Create account',
        'login.signup.title': 'Create account',
        'login.signup.hint': 'Use your company email address with a valid mail server. Free and disposable email addresses are not accepted. After email verification, we review your account.',
        'login.signup.submit': 'Create account',
        'login.signup.email.label': 'Email',
        'login.signup.email.placeholder': 'your@email.com',
        'logout.timer': 'Auto logout in: {time}',
        'dashboard.user': 'Signed in as',
        'dashboard.subtitle': 'Your customer area will be expanded step by step.',
        'dashboard.menu.email': 'Change email',
        'dashboard.menu.logout': 'Sign out',
        'email.title': 'Change email',
        'email.current.label': 'Current email',
        'email.current.placeholder': 'your@email.com',
        'email.new.label': 'New email',
        'email.new.placeholder': 'new@email.com',
        'email.submit': 'Change email',
        'mail.title': 'Mail settings',
        'mail.host.label': 'Mail server',
        'mail.host.placeholder': 'smtp.example.com',
        'mail.port.label': 'Port',
        'mail.port.placeholder': '587',
        'mail.user.label': 'Account',
        'mail.user.placeholder': 'user@example.com',
        'mail.pass.label': 'Password',
        'mail.pass.placeholder': '********',
        'mail.from.label': 'Sender email',
        'mail.from.placeholder': 'noreply@example.com',
        'mail.to.label': 'Recipient email',
        'mail.to.placeholder': 'test@example.com',
        'mail.tls': 'Use TLS (STARTTLS)',
        'mail.note': 'Password is stored encrypted.',
        'mail.save': 'Save settings',
        'mail.test': 'Send test email',
        'consents.panel.title': 'Consents & Agreements',
        'consents.loading': 'Loading...',
        'consents.error': 'Error loading consents.',
        'consents.retry': 'Retry',
        'consents.status.accepted': 'Confirmed',
        'consents.status.pending': 'Pending',
        'consents.label.privacy_consent': 'GDPR Consent',
        'consents.label.cloud_agreement': 'Cloud Agreement',
        'consents.label.terms_accepted': 'Terms & Conditions',
        'consents.label.privacy_notice_customer_portal': 'Privacy Policy',
        'consents.label.cookie_consent': 'Cookie Consent',
        'consents.meta.version': 'Version',
        'consents.meta.date': 'Date',
        'consents.cta.text': 'Some consents are still pending.',
        'consents.cta.button': 'Confirm now',
        'reactivation.status.title': 'Account Deactivated',
        'reactivation.status.message': 'Your account is deactivated. You have {days} days remaining to request reactivation.',
        'reactivation.status.ticket_open': 'There is already an open reactivation request ({ticket}).',
        'reactivation.status.ticket_status': 'Status: {status}',
        'reactivation.button.request': 'Request Reactivation',
        'reactivation.button.pending': 'Requesting...',
        'reactivation.email.sent': 'If a deactivated account exists, a link has been sent by email.',
        'reactivation.success.message': 'Reactivation request created. You will receive an email with further instructions.',
        'reactivation.error.generic': 'Reactivation failed. Please try again later.',
        'reactivation.page.title': 'Account Reactivation',
        'reactivation.page.subtitle': 'Confirm your identity to reactivate your account.',
        'reactivation.verify.success': 'Your email has been verified. You can now create a reactivation request.',
        'reactivation.ticket.info': 'Ticket: {number}',
        'reactivation.ticket.status': 'Status: {status}',
        'reactivation.ticket.hint': 'Click the button below to create your reactivation request.',
        'reactivation.ticket.create': 'Create Reactivation Request',
        'reactivation.ticket.creating': 'Creating...',
        'reactivation.ticket.created': 'Ticket created. Please confirm your identity.',
        'reactivation.stepup.hint': 'To complete your request, please confirm your identity with a passkey.',
        'reactivation.stepup.button': 'Confirm Identity with Passkey',
        'reactivation.stepup.pending': 'Please follow your passkey instructions...',
        'reactivation.stepup.success': 'Identity confirmed! Your request is being processed.',
        'reactivation.stepup.error': 'Confirmation failed. Please try again.',
        'reactivation.existing.ticket': 'You already have an open reactivation request.',
        'reactivation.existing.message': 'Your request is being processed. You will receive an email once your account is reactivated.',
        'reactivation.success.info': 'You will receive an email once your account is reactivated.',
        'admin.tickets.filter.reactivation': 'Reactivations',
        'admin.tickets.badge.reactivation': 'Reactivation',
        'admin.tickets.stepup.pending': 'Step-Up Pending',
        'admin.tickets.stepup.verified': 'Step-Up Verified',
        'admin.tickets.action.approve': 'Approve',
        'admin.tickets.action.reject': 'Reject',
        'admin.tickets.reject.reason': 'Rejection Reason',
        'admin.tickets.approve.success': 'Reactivation approved',
        'admin.tickets.reject.success': 'Reactivation rejected',
        'tickets.panel.title': 'My Support Tickets',
        'tickets.panel.empty': 'No tickets yet',
        'tickets.panel.empty.hint': 'Create a new ticket to get support.',
        'tickets.panel.create': 'New Ticket',
        'tickets.panel.back': 'Back to list',
        'tickets.panel.loading': 'Loading tickets...',
        'tickets.panel.error': 'Error loading tickets.',
        'tickets.panel.retry': 'Retry',
        'tickets.filter.status': 'Status',
        'tickets.filter.category': 'Category',
        'tickets.filter.all': 'All',
        'tickets.list.comments': 'comments',
        'tickets.detail.title': 'Ticket Details',
        'tickets.detail.description': 'Description',
        'tickets.detail.comments': 'Comments',
        'tickets.detail.noComments': 'No comments yet.',
        'tickets.detail.addComment': 'Add comment',
        'tickets.detail.commentPlaceholder': 'Your message...',
        'tickets.detail.commentSubmit': 'Submit',
        'tickets.detail.close': 'Close ticket',
        'tickets.detail.closeConfirm': 'Do you really want to close this ticket?',
        'tickets.detail.closeReason': 'Reason (optional)',
        'tickets.create.title': 'Create New Ticket',
        'tickets.create.subject': 'Subject',
        'tickets.create.subjectPlaceholder': 'Brief summary',
        'tickets.create.category': 'Category',
        'tickets.create.priority': 'Priority',
        'tickets.create.description': 'Description',
        'tickets.create.descriptionPlaceholder': 'Detailed description of your request...',
        'tickets.create.submit': 'Create Ticket',
        'tickets.create.cancel': 'Cancel',
        'tickets.create.success': 'Ticket created successfully',
        'tickets.create.error': 'Error creating ticket',
        'tickets.status.open': 'Open',
        'tickets.status.in_progress': 'In Progress',
        'tickets.status.waiting_customer': 'Your reply is needed',
        'tickets.status.waiting_internal': 'Internal review',
        'tickets.status.resolved': 'Resolved',
        'tickets.status.closed': 'Closed',
        'tickets.status.cancelled': 'Cancelled',
        'tickets.priority.low': 'Low',
        'tickets.priority.medium': 'Medium',
        'tickets.priority.high': 'High',
        'tickets.priority.urgent': 'Urgent',
        'tickets.category.general': 'General enquiry',
        'tickets.category.technical': 'Technical support',
        'tickets.category.billing': 'Invoices & contracts',
        'tickets.category.account': 'Access & users',
        'tickets.category.feature_request': 'Change request',
        'tickets.category.bug_report': 'Report a problem',
        'tickets.category.security': 'Security incident',
        'tickets.category.provision_request': 'Order / provisioning',
        'tickets.comment.success': 'Comment added',
        'tickets.comment.error': 'Error adding comment',
        'tickets.close.success': 'Ticket closed',
        'tickets.close.error': 'Error closing ticket',
        'tickets.attachments.label': 'Attachments (optional)',
        'tickets.attachments.select': 'Select files...',
        'tickets.attachments.hint': 'Max. 5 files, max. 10MB each. Allowed: Images, PDF, Office docs, Text, Logs.',
        'tickets.attachments.section': 'Attachments',
        'tickets.attachments.download': 'Download',
        'tickets.attachments.remove': 'Remove',
        'tickets.attachments.error.tooMany': 'Maximum 5 files allowed',
        'tickets.attachments.error.tooLarge': 'File too large (max. 10MB)',
        'tickets.attachments.error.invalidType': 'File type not allowed',
        'tickets.attachments.error.multi': '{count} files could not be added: {reasons}',
        'tickets.attachments.uploading': 'Uploading',
        'tickets.attachments.dropzoneHint': 'Drag files here or click to select',
        'tickets.reactivation.exists': 'An open reactivation request already exists.',
        'tickets.reactivation.link': 'Go to ticket',
        'consent.privacy.title': 'GDPR Consent',
        'consent.cloud.title': 'Cloud Agreement',
        'consent.terms.title': 'Terms & Conditions',
        'consent.accept': 'Accept',
        'consent.accepted': 'Consent saved successfully',
        // SLA Report Panel
        'admin.slaReport.title': 'SLA Compliance Report',
        'admin.slaReport.subtitle': 'Service Level Agreement Statistics',
        'admin.slaReport.filters': 'Filters',
        'admin.slaReport.dateFrom': 'From',
        'admin.slaReport.dateTo': 'To',
        'admin.slaReport.category': 'Category',
        'admin.slaReport.categoryAll': 'All Categories',
        'admin.slaReport.generate': 'Generate Report',
        'admin.slaReport.exportJson': 'JSON Export',
        'admin.slaReport.exportCsv': 'CSV Export',
        'admin.slaReport.summary': 'Summary',
        'admin.slaReport.totalTickets': 'Total Tickets',
        'admin.slaReport.ticketsWithSla': 'Tickets with SLA',
        'admin.slaReport.responseCompliance': 'Response Compliance',
        'admin.slaReport.resolutionCompliance': 'Resolution Compliance',
        'admin.slaReport.avgResponseTime': 'Avg Response Time',
        'admin.slaReport.avgResolutionTime': 'Avg Resolution Time',
        'admin.slaReport.breachesByCategory': 'Breaches by Category',
        'admin.slaReport.breachesByPriority': 'Breaches by Priority',
        'admin.slaReport.hours': 'hours',
        'admin.slaReport.noData': 'No data for the selected period',
        'admin.slaReport.loading': 'Loading SLA data...',
        'admin.slaReport.error': 'Error loading SLA report',
        'admin.slaReport.dateRangeError': 'Date range must not exceed 1 year',
        // Onboarding Tour
        'admin.onboarding.title': 'Welcome to Admin Dashboard',
        'admin.onboarding.subtitle': 'Learn the key features',
        'admin.onboarding.step': 'Step {current} of {total}',
        'admin.onboarding.steps.1.title': 'Welcome!',
        'admin.onboarding.steps.1.description': 'Welcome to the Cyberplex Admin Dashboard. Manage users, tickets, and system settings here.',
        'admin.onboarding.steps.2.title': 'User Management',
        'admin.onboarding.steps.2.description': 'Approve new accounts, manage users, and invite new users to the platform.',
        'admin.onboarding.steps.3.title': 'Support Tickets',
        'admin.onboarding.steps.3.description': 'Handle support requests and reactivation requests. SLA filters help with prioritization.',
        'admin.onboarding.steps.4.title': 'Audit Logs',
        'admin.onboarding.steps.4.description': 'Track all system activities in the audit log. Export filtered logs for compliance.',
        'admin.onboarding.steps.5.title': 'System Settings',
        'admin.onboarding.steps.5.description': 'Configure mail settings, create database backups, and manage signup options.',
        'admin.onboarding.steps.6.title': 'Ready!',
        'admin.onboarding.steps.6.description': 'You\'re all set! Click the help icon (?) in the top right if you have questions.',
        'admin.onboarding.back': 'Back',
        'admin.onboarding.next': 'Next',
        'admin.onboarding.skip': 'Skip',
        'admin.onboarding.finish': 'Finish',
        'admin.onboarding.skipConfirm': 'Skip the tour? You won\'t be able to restart it later.',
        // GDPR Export
        'admin.gdprExport.title': 'Data Export (GDPR)',
        'admin.gdprExport.description': 'Download all your stored data. Maximum 1 export per 24 hours.',
        'admin.gdprExport.button': 'Export My Data',
        'admin.gdprExport.loading': 'Creating export...',
        'admin.gdprExport.success': 'Export created! Download available until {expires}.',
        'admin.gdprExport.download': 'Download',
        'admin.gdprExport.error': 'Export failed. Please try again later.',
        'admin.gdprExport.rateLimit': 'You already requested an export. Please wait {hours} hours.',
        'admin.gdprExport.info': 'The export contains: User data, profile, company memberships, tickets, comments, audit logs.',
        // Home Panel
        'home.welcome': 'Welcome',
        'home.welcomeBack': 'Welcome back, {name}!',
        'home.stats.tickets': 'Open Tickets',
        'home.stats.companies': 'Your Companies',
        'home.stats.consents': 'Consents',
        'home.stats.pending': 'Pending',
        'home.actions.newTicket': 'New Ticket',
        'home.actions.manageCompany': 'Manage Company',
        'home.actions.consents': 'Consents',
        'home.actions.help': 'Help',
        'home.loading': 'Loading data...',
        'home.error': 'Failed to load data',
        // Notifications
        'notifications.title': 'Notifications',
        'notifications.empty': 'No new notifications',
        'notifications.markAsRead': 'Mark as read',
        'notifications.markAllRead': 'Mark all as read',
        'notifications.viewAll': 'View all',
        'notifications.justNow': 'Just now',
        'notifications.minutesAgo': '{count} minutes ago',
        'notifications.hoursAgo': '{count} hours ago',
        'notifications.daysAgo': '{count} days ago',
        'notifications.types.ticket_comment': 'Ticket Comment',
        'notifications.types.ticket_status': 'Ticket Status',
        'notifications.types.company_invite': 'Company Invitation',
        'notifications.types.reactivation': 'Reactivation',
        'notifications.types.security': 'Security',
        'notifications.types.system': 'System',
        // Onboarding
        'onboarding.step1.title': 'Welcome to Cyberplex!',
        'onboarding.step1.description': 'Get to know your customer portal.',
        'onboarding.step2.title': 'Your Dashboard',
        'onboarding.step2.description': 'See all important information at a glance.',
        'onboarding.step3.title': 'Support Tickets',
        'onboarding.step3.description': 'Create and manage support requests.',
        'onboarding.step4.title': 'Company Management',
        'onboarding.step4.description': 'Manage your company data and members.',
        'onboarding.next': 'Next',
        'onboarding.back': 'Back',
        'onboarding.skip': 'Skip',
        'onboarding.finish': 'Finish',
        // Search
        'search.placeholder': 'Search...',
        'search.open': 'Open search',
        'search.close': 'Close search',
        'search.loading': 'Searching...',
        'search.empty.title': 'No results',
        'search.empty.hint': 'Try a different search term',
        'search.error': 'Search failed',
        'search.sections.tickets': 'Tickets',
        'search.sections.companies': 'Companies',
        'search.sections.domains': 'Domains',
        // Version Footer
        'footer.version': 'Version'
    }
};

// Type definitions
interface TranslationData {
  [key: string]: string | TranslationData;
}

interface I18nInstance {
  currentLang: 'de' | 'en';
  init(): void;
  t(key: string, params?: Record<string, string | number>, fallback?: string): string;
  apply(lang: 'de' | 'en'): void;
  detectLanguage(): 'de' | 'en';
  formatDate(isoString: string | Date, options?: Intl.DateTimeFormatOptions): string;
  loadTranslations?(lang: string): Promise<void>;
}

// Simple I18n object
const I18n: I18nInstance = {
    currentLang: 'de',

    detectLanguage(): 'de' | 'en' {
        const saved = localStorage.getItem('cyberplex-lang');
        if (saved && translations[saved]) {
            return saved as 'de' | 'en';
        }

        const browserLang = navigator.language || (navigator as { userLanguage?: string }).userLanguage || 'de';
        const country = browserLang.split('-')[1]?.toLowerCase();

        // DACH countries: Germany, Austria, Switzerland
        if (['de', 'at', 'ch'].includes(country || '')) {
            return 'de';
        }

        const langCode = browserLang.split('-')[0].toLowerCase();
        return translations[langCode] ? (langCode as 'de' | 'en') : 'en';
    },

    apply(lang: 'de' | 'en'): void {
        if (!translations[lang]) return;

        this.currentLang = lang;
        document.documentElement.lang = lang;

        // Update text content
        document.querySelectorAll('[data-i18n]').forEach(el => {
            const key = el.getAttribute('data-i18n');
            if (key) {
                const value = translations[lang][key];
                if (value) {
                    el.textContent = value;
                }
            }
        });

        // Update placeholders
        document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
            const key = el.getAttribute('data-i18n-placeholder');
            if (key) {
                const value = translations[lang][key];
                if (value) {
                    (el as HTMLInputElement | HTMLTextAreaElement).placeholder = value;
                }
            }
        });

        // Update active button
        document.querySelectorAll('.cp-language-switcher__button').forEach(btn => {
            const btnLang = btn.getAttribute('data-lang');
            if (btnLang === lang) {
                btn.classList.add('cp-language-switcher__button--active');
            } else {
                btn.classList.remove('cp-language-switcher__button--active');
            }
        });

        // Save preference
        localStorage.setItem('cyberplex-lang', lang);
    },

    init(): void {
        const lang = this.detectLanguage();
        this.apply(lang);
    },

    t(key: string, params: Record<string, string | number> = {}, fallback?: string): string {
        const value = translations[this.currentLang]?.[key];
        if (!value) return fallback || key;

        // Simple parameter interpolation: {paramName}
        return value.replace(/\{(\w+)\}/g, (match: string, paramName: string) => {
            return params[paramName] !== undefined ? String(params[paramName]) : match;
        });
    },

    formatDate(date: string | Date, options: Intl.DateTimeFormatOptions = {}): string {
        const d = typeof date === 'string' ? new Date(date) : date;
        if (isNaN(d.getTime())) return '—';

        const defaultOptions: Intl.DateTimeFormatOptions = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };

        const locale = this.currentLang === 'de' ? 'de-DE' : 'en-US';
        return d.toLocaleString(locale, { ...defaultOptions, ...options });
    }
};

// Assign to window for global access
window.I18n = I18n;

})();
